import { render, staticRenderFns } from "./SEOText.vue?vue&type=template&id=01a6ace4&"
import script from "./SEOText.vue?vue&type=script&lang=js&"
export * from "./SEOText.vue?vue&type=script&lang=js&"
import style0 from "./SEOText.vue?vue&type=style&index=0&id=01a6ace4&prod&lang=css&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports